import React from 'react';
import { useCampaignListModel } from './model';
import { CampaignListView } from './view';

export const CampaignListWidget: React.FC = () => {
  const { state, reload } = useCampaignListModel();

  return <CampaignListView state={state} onRefresh={reload} />;
};

